module.exports = __webpack_public_path__ + "img/it.cc79b186.png";